import { Component } from '@angular/core';
import { DialogConfig } from '@app/components/dialog/dialog-config';
import { DialogRef } from '@app/components/dialog/dialog-ref';

@Component({
  selector: 'navaar-dialog-archive-item',
  templateUrl: './dialog-archive-item.component.html',
  styleUrls: ['./dialog-archive-item.component.scss']
})
export class DialogArchiveItemComponent {
  private readonly productId: string;
  public title: string;
  constructor(private readonly dialogRef: DialogRef, private readonly dialogConfig: DialogConfig) {
    this.productId = dialogConfig.data.productId;
    this.title = dialogConfig.data.title;
  }

  public removeItem(): void {
    this.dialogRef.close({
      remove: true,
      productId: this.productId
    });
  }
  public cancel() {
    this.dialogRef.close({
      remove: false,
      productId: this.productId
    });
  }
}